import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { YesNo } from 'constants/enums/yesNo.enum';
import { STEP, styles, evalTableRow, evalObject, PetType, Gender } from 'containers/InsureProcess/InsureProcseePet/types';
import { DatePicker } from 'formik-antd';
import { Moment } from 'moment';
import moment from 'moment-timezone';
import { SysOption } from 'bff/models/info';
import Accordion from 'components/Accordion';
// import PDFViewer from 'components/PDFViewer';
import { Link } from 'bff/models/link';
import CalcPlansTable from 'containers/InsureProcess/InsureProcseePet/CalcPlansTable';
import service from 'bff/services/petProductService';
import apiCommonService from 'bff/services/commonService';
import commonService from 'utils/commonService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { InsType } from 'constants/enums/insType.enum';
import PetFormikFocusError from './PetFormikFocusError';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { setGuardianshipStatementModalVisibleAction } from 'redux/actions/modal.action';
import { CodeId } from 'constants/enums/codeId.enum';
import PDFAllPageViewer from 'components/PDFAllPageViewer';
import memberProfileService from 'bff/services/memberProfileService';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';

interface InitForm {
  policyHolderId: String,
  policyHolderBirthday: String,
  startDate: any,
  // 條款勾選
  isDeclear: '', // 是否受監護宣告
  CONTRACTS: { check: boolean }[],
  ALL_CONTRACHS_CHECKED: false,
  selectedCalcPlan: {},
  sysTime: 0,
  evalResult: {},
  evalTableData: Array<evalTableRow>,
  showCalcPlans: boolean,
  programId: '',
  agreeGetPetList: boolean,
}

const initForm: InitForm = {
  policyHolderId: '',
  policyHolderBirthday: '',
  startDate: '',
  // 條款勾選
  isDeclear: '', // 是否受監護宣告
  CONTRACTS: new Array(0),
  ALL_CONTRACHS_CHECKED: false,
  selectedCalcPlan: {},
  sysTime: 0,
  evalResult: {},
  evalTableData: new Array<evalTableRow>(0),
  showCalcPlans: false,
  programId: '',
  agreeGetPetList: false
};

interface PetTableDataType {
  key: React.Key;
  REPOLICY_NO?: string;
  PET_CHIP: string;
  PET_NAME: string;
  END_DATE?: string;
  CHIP_RENEW_DPLY_BGN: Moment | null;
  RENEW_STATUS: string;
}

interface PetInfoTableDataType {
  key: React.Key;
  PET_NAME: string;
  PET_KIND: string;
  PET_VAR_NAME: string;
  PET_BDAY: string;
  PET_AGE: string;
  PET_POLICY_AGE: string;
  PET_STERIL: string;
  PET_SEX: string;
}

interface HideFieldType {
  policyHolderId: boolean;
  policyHolderBirthday: boolean;
}

function InsureProcessTrialCalc (props: any) {
  const [showCalcPlans, setShowCalcPlans] = useState<boolean>(false);
  const [submitBtnStatus, setSubmitBtnStatus] = useState('');
  const [petTableData, setPetTableData] = useState<PetTableDataType[] | null>(null);
  const [selectedRowKey, setSelectedRowKey] = useState<string | null>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [petInfo, setPetInfo] = useState<any>(null);
  const [petInfoTableData, setPetInfoTableData] = useState<PetInfoTableDataType[] | null>(null);
  const [state, setState] = useState<any>({
    sysTime: 0,
    evalResult: {},
    evalTableData: new Array<evalTableRow>(0),
    termStatus: [],
    memberId: '',
    memberInfo: {},
    renewalInfo: new Array(0)
  });
  const [hideField, setHideField] = useState<HideFieldType>({
    policyHolderId: true,
    policyHolderBirthday: true
  });

  const formikRef1: any = React.useRef();
  const calcRef = useRef<HTMLInputElement>(null);

  const petTableColumns: ColumnsType<PetTableDataType> = [
    {
      title: '晶片號碼',
      dataIndex: 'PET_CHIP'
    },
    {
      title: '寵物姓名',
      dataIndex: 'PET_NAME'
    },
    {
      title: '預定生效日',
      dataIndex: 'startDate',
      render: function startDateSelect (_, __, index) {
        let isDisabled = true;

        if (petTableData) {
          const currentData = petTableData[index];
          if (currentData.RENEW_STATUS === '0') isDisabled = selectedRowKey !== currentData.key;
        }

        return (
          <DatePicker
            name="startDate"
            className="element__input"
            data-fieldname="startDate"
            format="YYYY/MM/DD"
            showToday={false}
            validate={(val) => {
              if (!val) return '此為必填欄位';
              return '';
            }}
            disabledDate={(current: Moment) => {
              if (!current) return false;
              const nzDate = commonService.normalizeTime(current.format('YYYY-MM-DD'), state.sysTime);
              return handleGetDisabledDate(nzDate);
            }}
            onFocus={fetchSysTime}
            onChange={(val: any) => handleStartDayOnChange(val, formikRef1.current.setFieldValue, index)}
            value={petTableData && petTableData[index].CHIP_RENEW_DPLY_BGN}
            disabled={isDisabled}
          />
        );
      }
    },
    {
      title: '備註',
      render: function rederNote (_, record) {
        let text;

        switch (true) {
          case record.RENEW_STATUS === '2':
            text = '重複投保';
            break;
          case record.RENEW_STATUS === '3':
            text = '未到續保時間';
            break;
          case !record.PET_CHIP:
            text = '無寵物晶片';
            break;
          case !record.PET_NAME:
            text = '無寵物姓名';
            break;
          case !record.CHIP_RENEW_DPLY_BGN:
            text = '無預定生效日';
            break;
        }

        return (
          <span className="ant-picker-exam-info">{text}</span>
        );
      }
    }
  ];

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
    columnTitle: '選取投保',
    onChange: async (selectedRowKeys: React.Key[], selectedRows: PetTableDataType[]) => {
      setSelectedRowKey(selectedRowKeys[0].toString());
      setSelectedRow(selectedRows[0]);
      resetEvalResult(formikRef1.current.setFieldValue);
      setPetInfoTableData(null);
      formikRef1.current.setFieldValue('startDate', selectedRows[0].CHIP_RENEW_DPLY_BGN);
      clearLocalStorage();
    },
    getCheckboxProps: (record: PetTableDataType) => ({
      disabled: record.RENEW_STATUS === '2' ||
        record.RENEW_STATUS === '3' ||
        !record.PET_NAME ||
        !record.PET_CHIP ||
        !record.CHIP_RENEW_DPLY_BGN,
      name: record.PET_NAME
    })
  };

  const petInfoTableColumns: ColumnsType<PetInfoTableDataType> = [
    {
      title: '寵物姓名',
      dataIndex: 'PET_NAME'
    },
    {
      title: '種類',
      dataIndex: 'PET_KIND'
    },
    {
      title: '品種',
      dataIndex: 'PET_VAR_NAME'
    },
    {
      title: '寵物出生年月',
      dataIndex: 'PET_BDAY'
    },
    {
      title: '寵物年齡',
      dataIndex: 'PET_AGE'
    },
    {
      title: '保險年齡',
      dataIndex: 'PET_POLICY_AGE'
    },
    {
      title: '絕育狀態',
      dataIndex: 'PET_STERIL'
    },
    {
      title: '寵物性別',
      dataIndex: 'PET_SEX'
    }
  ];

  const handleToggleView = (fieldname: keyof HideFieldType) => {
    setHideField(prev => ({
      ...prev,
      [fieldname]: !hideField[fieldname]
    }));
  };

  const getPetAge = (date: string, startDate: Moment) => {
    if (!startDate) return { years: '-', months: '-', insureYear: '-' };
    const petBirthDay = moment(date, 'YYYYMM');
    const petAgeY = Math.floor(((startDate.year() * 12 + startDate.month()) - (petBirthDay.year() * 12 + petBirthDay.month())) / 12);
    const petAgeM = ((startDate.year() * 12 + startDate.month()) - (petBirthDay.year() * 12 + petBirthDay.month())) % 12;
    const petPolicyAge = petAgeM > 6 ? petAgeY + 1 : petAgeY;
    return {
      years: isNaN(petAgeY) ? '-' : petAgeY,
      months: isNaN(petAgeM) ? '-' : petAgeM,
      insureYear: isNaN(petPolicyAge) ? '-' : petPolicyAge
    };
  };

  const fetchSysTime = async () => {
    const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
    setState((prev: any) => (
      {
        ...prev,
        sysTime: sysTime
      }
    ));
  };

  /**
   * @description 取得不可選取日期
   */
  const handleGetDisabledDate = (current: any) => {
    // 改以系統時間判斷，並將時區已校準至台灣時區
    // 不用在中午12點換日
    // const dayShift = moment.unix(state.sysTime).hour() >= 12 ? 0 : -1;
    // 晚上11點換日
    const dayShift = moment.unix(state.sysTime).hour() >= 23 ? 1 : 0;
    return current <= moment.unix(state.sysTime).add(dayShift, 'd') || current > moment.unix(state.sysTime).add(7 + dayShift, 'd');
  };

  const handleStartDayOnChange = (val: any, setFieldValue: any, index: number) => {
    if (!val) return;
    const nzDate = commonService.normalizeTime(val.format('YYYY-MM-DD'), state.sysTime);
    const newPetTableDate = petTableData && [...petTableData];

    if (newPetTableDate) newPetTableDate[index].CHIP_RENEW_DPLY_BGN = nzDate;

    setFieldValue('startDate', nzDate);
    if (newPetTableDate) setPetTableData(prev => ([...newPetTableDate]));

    resetEvalResult(setFieldValue);
    setPetInfoTableData(null);
  };

  const fetchApplyNo = async () => {
    const req = {
      BC_TYPE: 'C',
      PROD_ID: 'PTI',
      SERIAL_TYPE: 'A'
    };
    const res = await service.fetchPolicyNo(req);
    return res.TRANRS.SERIALNO;
  };

  const getPetListOnClick = async () => {
    const memberId = storageService.getItem(storageKeys.MemberId);

    const chipInfo = await service.fetchChipInfo({ INSURED_ID: memberId });
    const renewalInfo = await service.fetchRenewalInfo({ MEMBER_ID: memberId });
    const renewalInfoMap = renewalInfo && new Map(renewalInfo.map((data: any) => [data.PET_CHIP, { REPOLICY_NO: data.POLICY_NO }]));

    if (chipInfo) {
      const tableData = chipInfo.map((data: any) => {
        const renewalData: any = renewalInfoMap && renewalInfoMap.get(data.PET_CHIP);

        return ({
          ...data,
          key: data.PET_CHIP,
          CHIP_RENEW_DPLY_BGN: data.CHIP_RENEW_DPLY_BGN ? moment(data.CHIP_RENEW_DPLY_BGN, 'YYYY-MM-DD') : null,
          REPOLICY_NO: renewalData && renewalData.REPOLICY_NO
        });
      });

      setPetTableData(tableData);
    }
  };

  const handleFormSubmit = async (val: any, action: any) => {
    const endDate = moment(val.startDate.format('YYYY-MM-DD')).add(1, 'y').format('YYYYMMDD');
    switch (submitBtnStatus) {
      case ('eval'): {
        const petInfoRes = await service.fetchPetInfo({
          PET_CHIP_DATAS: [
            {
              INSURED_ID: state.memberId,
              INSURED_BIRTH: moment(state.memberInfo.BIRTHDAY, 'YYYYMMDD').format('YYYY-MM-DD'),
              PET_CHIP: selectedRow.PET_CHIP
            }
          ]
        });
        const petInfo = petInfoRes[0];

        setPetInfo({
          ...petInfo,
          REPOLICY_NO: selectedRow?.REPOLICY_NO,
          PET_BDAY: petInfo.PET_BDAY + '01'
        });

        const petAgeY = getPetAge(petInfo.PET_BDAY, val.startDate).years;
        const petAgeMM = getPetAge(petInfo.PET_BDAY, val.startDate).months;

        setPetInfoTableData([
          {
            key: petInfo.PET_CHIP,
            PET_NAME: petInfo.PET_NAME,
            PET_KIND: petInfo.PET_KIND === PetType.dog ? '狗' : petInfo.PET_KIND === PetType.cat ? '貓' : '',
            PET_VAR_NAME: petInfo.PET_VAR_NAME,
            PET_BDAY: moment(petInfo.PET_BDAY, 'YYYYMM').format('YYYY/MM'),
            PET_AGE: petAgeY === '0' ? '' : (petAgeY + '歲') + petAgeMM + '個月',
            PET_POLICY_AGE: getPetAge(petInfo.PET_BDAY, val.startDate).insureYear + '歲',
            PET_STERIL: petInfo.PET_STERIL === '0' ? '否' : petInfo.PET_STERIL === '1' ? '是' : '',
            PET_SEX: petInfo.PET_SEX === Gender.male ? '公' : petInfo.PET_SEX === Gender.female ? '母' : ''
          }
        ]);

        if (selectedRow?.RENEW_STATUS === '0') {
          if ((+petAgeY === 0 && +petAgeMM < 2) || (+petAgeY === 8 && +petAgeMM > 6) || +petAgeY < 0 || +petAgeY > 8) {
            sweetAlertService.info('寵物年齡須大於等於2個月並小於等於8歲6個月');
            resetEvalResult(formikRef1.current.setFieldValue);

            return;
          }
        }

        // calc btn on click
        const req = {
          PET_KIND: petInfo.PET_KIND,
          PET_VAR_NO: petInfo.PET_VAR_NO,
          PET_VAR_NAME: petInfo.PET_VAR_NAME,
          PET_STERIL: petInfo.PET_STERIL,
          PET_BDAY: petInfo.PET_BDAY + '01',
          START_DATE: val.startDate.format('YYYYMMDD'),
          END_DATE: endDate,
          PET_CHIP: petInfo.PET_CHIP,
          AGREE_TIME_TERMS: val.ALL_CONTRACT_CHECKED_TIME
        };

        const evalres = await service.evalPet(req);

        if (!evalres) return;

        const evalTableData: Array<evalTableRow> = [
          {
            title: '每一保險事故保險金額',
            value: []
          },
          {
            title: '保險期間內累積最高賠償限額',
            value: []
          },
          {
            title: '自負額',
            value: []
          },
          {
            title: '每一保險事故保險金額',
            value: []
          },
          {
            title: '保險期間內累積最高賠償限額',
            value: []
          },
          {
            title: '自負額',
            value: []
          },
          {
            title: '每一保險事故保險金額',
            value: []
          },
          {
            title: '保險期間內累積最高賠償限額',
            value: []
          },
          {
            title: '自負額',
            value: []
          },
          {
            title: '寵物侵權責任',
            value: []
          },
          {
            title: '寵物協尋廣告費用',
            value: []
          },
          {
            title: '被保險人住院期間寄宿日額費用(每日)',
            value: []
          },
          {
            title: '寵物喪葬費用',
            value: []
          },
          {
            title: '寵物重新取得費用',
            value: []
          },
          {
            title: '保險費',
            value: []
          }
        ];
        evalres.TRANRS.PET_PLAN.forEach((data: evalObject) => {
          evalTableData[0].value.push(data.AMOUNT1);
          evalTableData[1].value.push(data.AMOUNT10);
          evalTableData[2].value.push(data.DEDUCTIBLE1);
          evalTableData[3].value.push(data.AMOUNT2);
          evalTableData[4].value.push(data.AMOUNT11);
          evalTableData[5].value.push(data.DEDUCTIBLE2);
          evalTableData[6].value.push(data.AMOUNT3);
          evalTableData[7].value.push(data.AMOUNT12);
          evalTableData[8].value.push(data.DEDUCTIBLE3);
          evalTableData[9].value.push(data.AMOUNT5);
          evalTableData[10].value.push(data.AMOUNT6);
          evalTableData[11].value.push(data.AMOUNT7);
          evalTableData[12].value.push(data.AMOUNT8);
          evalTableData[13].value.push(data.AMOUNT9);
          evalTableData[14].value.push(data.PREMIUM);
        });
        setState({
          ...state,
          evalResult: evalres.TRANRS.PET_PLAN,
          evalTableData: evalTableData
        });
        formikRef1.current.setFieldValue('evalResult', evalres.TRANRS.PET_PLAN);
        formikRef1.current.setFieldValue('evalTableData', evalTableData);
        formikRef1.current.setFieldValue('showCalcPlans', true);

        if (!showCalcPlans) setShowCalcPlans(true);

        window.scroll({
          top: calcRef.current ? calcRef.current.offsetTop + 200 : 0,
          behavior: 'smooth'
        });

        props.addToCartGTM(evalres.TRANRS.PET_PLAN, val);

        break;
      }
      case ('next'): {
        // 如有填入專案代碼，判斷專案代碼是否存在
        storageService.removeItem(storageKeys.PetProgramCode);
        if (val.programId) {
          const res = await apiCommonService.verifyProgramId(val.programId, props.state.insTypeId);

          if (typeof res === 'string') {
            formikRef1.current.setFieldError('programId', res);
            return;
          }

          if (res && res.PROGRAM_ID) {
            storageService.setItem(storageKeys.PetProgramCode, res.PROGRAM_ID);
          }
        }

        const pidRes: any = await memberProfileService.validMemberId(state.memberId);

        if (pidRes.NATIVE === 'F') {
          sweetAlertService.info('要、被保險人應為本國籍自然人。');
          return;
        }

        const applyNo = await fetchApplyNo();

        props.setState((prev: any) => ({
          ...prev,
          applyNo: applyNo,
          startDate: val.startDate.format('YYYYMMDD'),
          endDate: endDate,
          petChip: petInfo.PET_CHIP,
          selectedCalcPlan: val.selectedCalcPlan,
          petName: petInfo.PET_NAME,
          petKind: petInfo.PET_KIND,
          petBDay: petInfo.PET_BDAY,
          petVarNo: petInfo.PET_VAR_NO,
          petVarName: petInfo.PET_VAR_NAME,
          petVarType: val.selectedCalcPlan.PET_VAR_TYPE,
          petSteril: petInfo.PET_STERIL,
          ALL_CONTRACT_CHECKED_TIME: val.ALL_CONTRACT_CHECKED_TIME,
          petAgeY: getPetAge(petInfo.PET_BDAY, val.startDate).years,
          petAgeMM: getPetAge(petInfo.PET_BDAY, val.startDate).months,
          petPolicyAge: val.selectedCalcPlan.PET_POLICY_AGE,
          prodId: val.selectedCalcPlan.PLAN_ID,
          isDeclear: val.isDeclear,
          CONTRACTS: val.CONTRACTS,
          ALL_CONTRACHS_CHECKED: val.ALL_CONTRACHS_CHECKED,
          evalResult: state.evalResult,
          evalTableData: state.evalTableData,
          showCalcPlans,
          repolicyNo: petInfo.REPOLICY_NO,
          programId: val.programId,
          petGender: petInfo.PET_SEX,
          vaccineDate: petInfo.PET_VACCINATION
        }));

        const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
        const originTempCalcForm = originTempData &&
          originTempData.tempCalcForm
          ? originTempData.tempCalcForm : {};
        const originTempInformationForm = originTempData &&
          originTempData.tempInformationForm
          ? originTempData.tempInformationForm : {};

        commonService.storageData(storageKeys.InsurceProcessPetState, {
          ...originTempData,
          applyNo: applyNo,
          tempCalcForm: {
            ...originTempCalcForm,
            applyNo: applyNo,
            endDate: endDate,
            petChip: petInfo.PET_CHIP,
            petName: petInfo.PET_NAME,
            petKind: petInfo.PET_KIND,
            petBDay: petInfo.PET_BDAY,
            petVarNo: petInfo.PET_VAR_NO,
            petVarName: petInfo.PET_VAR_NAME,
            petVarType: val.selectedCalcPlan.PET_VAR_TYPE,
            petSteril: petInfo.PET_STERIL,
            petAgeY: getPetAge(petInfo.PET_BDAY, val.startDate).years,
            petAgeMM: getPetAge(petInfo.PET_BDAY, val.startDate).months,
            petPolicyAge: val.selectedCalcPlan.PET_POLICY_AGE,
            evalResult: state.evalResult,
            evalTableData: state.evalTableData,
            showCalcPlans,
            repolicyNo: petInfo.REPOLICY_NO,
            petInfo,
            petTableData,
            selectedRow,
            selectedRowKey,
            petInfoTableData
          },
          tempInformationForm: {
            ...originTempInformationForm,
            petGender: petInfo.PET_SEX,
            vaccineDate: petInfo.PET_VACCINATION
          }
        });

        props.beginCheckoutGTM(val.selectedCalcPlan, val);

        props.handleStep(STEP.infoFill);

        break;
      }
    }
  };

  const resetEvalResult = (setFieldValue: any) => {
    setShowCalcPlans(false);
    setFieldValue('showCalcPlans', false);
    setFieldValue('selectedCalcPlan', {});
    setFieldValue('evalResult', {});
    setFieldValue('evalTableData', []);
    setState((prev: any) => ({
      ...prev,
      evalResult: {},
      evalTableData: []
    }));
  };

  const resetAllPetTabelData = () => {
    setPetTableData(null);
    setPetInfoTableData(null);
    setSelectedRow(null);
    setSelectedRowKey(null);
  };

  const clearLocalStorage = () => {
    storageService.removeItem(storageKeys.InsurceProcessPetState);
  };

  const handleGetContracts = (contractLinks: Link[]) => {
    const res = new Array(0);
    if (contractLinks && contractLinks.length > 0) {
      contractLinks.forEach((contractLink: Link) => {
        res.push({
          LINK_NAME: contractLink.NAME,
          LINK_URL: contractLink.URL,
          CONTRACT: false
        });
      });
    }
    return res;
  };

  /**
   * @description 根據路徑下載檔案
  */
  const handleDownloadFile = (event: React.MouseEvent<HTMLButtonElement>, linkUrl: string, fileName: string) => {
    event.stopPropagation();
    try {
      commonService.downloadFile(linkUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  };

  const handleIsLogin = async (setFieldValue: any) => {
    const memberId = storageService.getItem(storageKeys.MemberId);

    if (memberId) {
      setState((prev: any) => ({
        ...prev,
        memberId
      }));

      const memberInfo = await memberProfileService.fetchMemberProfile(memberId);

      if (memberInfo) {
        setState((prev: any) => ({
          ...prev,
          memberInfo
        }));
      }

      setFieldValue('policyHolderId', memberInfo?.MEMBER_ID);
      setFieldValue('policyHolderBirthday', moment(memberInfo?.BIRTHDAY));
    }
  };

  const setTempFieldValue = async (tempData: any, setFieldValue: any) => {
    await setFieldValue('startDate', tempData.startDate ? moment(tempData.startDate) : '', true);
    await setFieldValue('isDeclear', tempData.isDeclear, true);
    await setFieldValue('CONTRACTS', tempData.CONTRACTS, true);
    await setFieldValue('ALL_CONTRACHS_CHECKED', tempData.ALL_CONTRACHS_CHECKED, true);
    await setFieldValue('selectedCalcPlan', tempData.selectedCalcPlan, true);
    await setFieldValue('evalResult', tempData.evalResult, true);
    await setFieldValue('evalTableData', tempData.evalTableData, true);
    await setFieldValue('showCalcPlans', tempData.showCalcPlans, true);
    await setFieldValue('ALL_CONTRACT_CHECKED_TIME', tempData.ALL_CONTRACT_CHECKED_TIME, true);
    await setFieldValue('programId', tempData.programId, true);
    await setFieldValue('agreeGetPetList', tempData.agreeGetPetList, true);
  };

  useEffect(() => {
    const setFieldValue = formikRef1.current.setFieldValue;

    fetchSysTime();
    handleIsLogin(setFieldValue);

    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)) ? JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)).tempCalcForm : null;
    if (tempData && formikRef1.current) {
      setTempFieldValue(tempData, formikRef1.current.setFieldValue);
      setState((prev: any) => ({
        ...prev,
        evalResult: tempData.evalResult ? tempData.evalResult : {},
        evalTableData: tempData.evalTableData ? tempData.evalTableData : new Array<evalTableRow>(0)
      }));
      setShowCalcPlans(tempData.showCalcPlans);
      setPetInfo(tempData.petInfo);
      if (tempData.petTableData) {
        setPetTableData(tempData.petTableData.map((data: any) => ({
          ...data,
          CHIP_RENEW_DPLY_BGN: data.CHIP_RENEW_DPLY_BGN ? moment(data.CHIP_RENEW_DPLY_BGN) : ''
        })));
      }
      setSelectedRow(tempData.selectedRow);
      setSelectedRowKey(tempData.selectedRowKey);
      setPetInfoTableData(tempData.petInfoTableData);
    }

    return () => {
      const petAcitiveState = JSON.parse(storageService.getItem(storageKeys.PetActiveProdId));
      const tempProdId = petAcitiveState ? petAcitiveState.PROD_ID : '';
      const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
      const originTempCalcForm = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)) &&
        JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)).tempCalcForm
        ? JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)).tempCalcForm : {};
      const tempData = {
        ...originTempData,
        tempCalcForm: {
          ...originTempCalcForm,
          ...formikRef1.current.values
        },
        prodId: formikRef1.current.values.selectedCalcPlan.PLAN_ID || tempProdId,
        insTypeId: petAcitiveState ? petAcitiveState.INS_TYPE_ID : InsType.Pet,
        programId: petAcitiveState ? petAcitiveState.PROGRAM_ID : ''
      };
      commonService.storageData(storageKeys.InsurceProcessPetState, tempData);
      commonService.storageData(storageKeys.PetActiveProdId, {
        INS_TYPE_ID: petAcitiveState ? petAcitiveState.INS_TYPE_ID : InsType.Pet,
        PROGRAM_ID: petAcitiveState ? petAcitiveState.PROGRAM_ID : '',
        PROD_ID: formikRef1.current.values.selectedCalcPlan.PLAN_ID || tempProdId
      });
    };
  }, []);

  useEffect(() => {
    const contracts = handleGetContracts(props.apiInfo.docLinks);
    setState((prev: any) => ({
      ...prev,
      termStatus: commonService.getInitTermStatus(contracts)
    }));
    initForm.CONTRACTS = contracts.map(() => ({ check: false }));
  }, [props.apiInfo.docLinks]);

  return (
    <div className="insure-process-building-info" style={props.activeStep === STEP.calcBill ? undefined : styles.inline}>
      <Formik
        innerRef={formikRef1}
        initialValues={initForm}
        // validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(val: any, action) => {
          // console.log('🚀 ~ step1 val:', val);
          handleFormSubmit(val, action);
        }}
        isInitialValid
      >
        {({ values, errors, touched, handleBlur, handleChange, setFieldValue, setFieldTouched, isValid, validateForm }) => (
          <Form noValidate>
            <div className="insure-process-building-info__content">
              <div className="building-info">
                <div className="building-info__title">飼主資料/要保人/被保險人資料</div>
                <div className="building-info__content owner-data">
                  <div className="building-info__row">
                    <div className={'element__form-group' + (errors.policyHolderId && touched.policyHolderId ? ' element__form-group--invalid' : '')}>
                      <div className="element__form-group-title">身分證字號*</div>
                      <div className="element__form-group-content">
                        {hideField.policyHolderId
                          ? (
                            <input
                              type="text"
                              className="element__input"
                              name="policyHolderId"
                              value={commonService.hiddenStringLastCharacter(values.policyHolderId, 5)}
                              disabled
                            />
                          )
                          : (
                            <Field
                              type="text"
                              name="policyHolderId"
                              length={10}
                              data-fieldname="policyHolderId"
                              className="element__input"
                              autoComplete="off"
                              onChange={(e: any) => {
                                handleChange(e);
                              }}
                              value={values.policyHolderId}
                              validate={(val: string) => {
                                if (!val) return '此為必填欄位';
                                if (val.length !== 10) return '身分證應為10碼';
                                return '';
                              }}
                              disabled
                            />
                          )}
                        <button type="button" className="element__view-btn" onClick={() => handleToggleView('policyHolderId')}>
                          {hideField.policyHolderId ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
                        </button>
                      </div>
                      <div className="element__error-message">
                        <ErrorMessage name="policyHolderId" />
                      </div>
                    </div>
                  </div>
                  <div className="building-info__row">
                    <div className={'element__form-group' + (errors.policyHolderBirthday && touched.policyHolderBirthday ? ' element__form-group--invalid' : '')}>
                      <div className="element__form-group-title">出生年月日*</div>
                      <div className="element__form-group-content">
                        {hideField.policyHolderBirthday
                          ? (
                            <input
                              type="text"
                              className="element__input"
                              name="policyHolderBirthday"
                              value={commonService.hiddenStringLastCharacter(moment(values.policyHolderBirthday).format('YYYY'), 2) + '/**/**'}
                              disabled
                            />
                          )
                          : (
                            <DatePicker
                              name="policyHolderBirthday"
                              className="element__input"
                              data-fieldname="policyHolderBirthday"
                              format="YYYY/MM/DD"
                              showToday={false}
                              validate={(val) => {
                                if (!val) return '此為必填欄位';
                                return '';
                              }}
                              disabled
                            />
                          )}
                        <button type="button" className="element__view-btn" onClick={() => handleToggleView('policyHolderBirthday')}>
                          {hideField.policyHolderBirthday ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
                        </button>
                      </div>
                      <div className="element__error-message">
                        <ErrorMessage name="policyHolderBirthday" />
                      </div>
                    </div>
                  </div>
                  {/* 條款勾選 */}
                  <div className="building-info__title">聲明事項</div>
                  <div className="building-info__row">
                    <div className="element__form-group" id="declared-form-group">
                      {/* <div className={'element__form-group' + (errors.DECLARED && touched.DECLARED ? ' element__form-group--invalid' : '')} id="declared-form-group"> */}
                      <div className="element__form-group-title">
                        要/被保險人是否受監護宣告?
                        <span className="element__link" onClick={() => props.setGuardianshipStatementModalVisible(true)}>(什麼是監護宣告?)</span>
                      </div>
                      <div className="element__form-group-content">
                        {props.state.yesNoSysOpt.map((sysOpt: SysOption, index: number) => {
                          return (
                            <div className="element__radio-group" key={index}>
                              <label htmlFor={`undeclared-radio-${sysOpt.PARAM_VALUE}`}>
                                <div className="element__radio">
                                  <Field
                                    type="radio"
                                    name="isDeclear"
                                    id={`undeclared-radio-${sysOpt.PARAM_VALUE}`}
                                    value={sysOpt.PARAM_VALUE}
                                    onChange={(e: any) => {
                                      handleChange(e);
                                      resetEvalResult(setFieldValue);
                                      resetAllPetTabelData();
                                    }}
                                  />
                                  <div className="element__radio-btn" />
                                </div>
                                <span>{sysOpt.PARAM_TEXT}</span>
                              </label>
                              {/* sysOpt.PARAM_VALUE === YesNo.Yes ? <div className="element__link" onClick={() => this.props.setGuardianshipStatementModalVisible(true)}>(什麼是監護宣告?)</div> : null */}
                            </div>);
                        })}
                      </div>
                      <div className="element__error-message">
                        <ErrorMessage name="isDeclear" />
                        {/* {values.DECLARED === YesNo.Yes && (
                                  commonService.getCodeMsg(this.props.UICodes, CodeId.W001)
                                )} */}
                      </div>
                    </div>
                  </div>
                  {
                    props.apiInfo ? (
                      <FieldArray name="CONTRACTS">
                        {
                          () => (
                            <Accordion>
                              {
                                props.apiInfo.docLinks.map((doc: Link, index: number) => {
                                  return (
                                    <Accordion.Item
                                      key={index}
                                      updateStatus={(openVal: any) => {
                                        // 更新條款狀態
                                        setState((prev: any) => ({
                                          ...prev,
                                          termStatus: commonService.headerClickUpdateTermStatus(openVal, index, state.termStatus)
                                        }));
                                      }}
                                      isActive={commonService.setPDFOpen(index, state.termStatus)}
                                    >
                                      {doc.URL.includes('.pdf') ? (
                                        <Accordion.Header title={doc.NAME}>
                                          {/* // todo download */}
                                          <button disabled={values.isDeclear === YesNo.Yes} type="button" className="review-terms__download-btn" onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleDownloadFile(event, doc.URL, doc.NAME)} />
                                        </Accordion.Header>
                                      ) : (
                                        <Accordion.Header title={doc.NAME} link={doc.URL} />
                                      )}
                                      <Accordion.Content>
                                        {doc.URL.includes('.pdf') && (
                                          <PDFAllPageViewer
                                            url={doc.URL}
                                            show={commonService.setPDFOpen(index, state.termStatus) || false}
                                            updateStatus={(bottom: any) => {
                                              // 更新條款狀態
                                              setState((prev: any) => ({
                                                ...prev,
                                                termStatus: commonService.headerScrollUpdateTermStatus(bottom, index, state.termStatus)
                                              }));
                                            }}
                                            checkContracts={values.isDeclear !== YesNo.Yes ? () => {
                                              setFieldValue(`CONTRACTS[${index}].checked`, true);
                                            } : () => { }}
                                          />
                                        )}
                                      </Accordion.Content>
                                      <Accordion.Addition>
                                        <div className="element__checkbox-group">
                                          <label htmlFor={`online-ins-checkbox${index + 1}`}>
                                            <div className="element__checkbox">
                                              <Field
                                                disabled={values.isDeclear === YesNo.Yes || commonService.setPDFCheckable(index, state.termStatus)}
                                                type="checkbox"
                                                name={`CONTRACTS[${index}].checked`}
                                                id={`online-ins-checkbox${index + 1}`}
                                                onChange={(e: any) => {
                                                  handleChange(e);
                                                  if (!e.currentTarget.checked) setFieldValue('ALL_CONTRACHS_CHECKED', false);
                                                  setState((prev: any) => ({
                                                    ...prev,
                                                    termStatus: commonService.updateTermStatus(e.currentTarget.checked, index, state.termStatus)
                                                  }));
                                                  resetEvalResult(setFieldValue);
                                                  resetAllPetTabelData();
                                                }}
                                              />
                                              <div className="element__checkbox-btn" />
                                            </div>
                                            <span>審閱條款</span>
                                          </label>
                                        </div>
                                      </Accordion.Addition>
                                    </Accordion.Item>
                                  );
                                })
                              }
                            </Accordion>
                          )
                        }
                      </FieldArray>
                    ) : ''
                  }
                  <div style={{ padding: 20 }}>
                    <div className="element__checkbox-group">
                      <label htmlFor="all-checked-checkbox">
                        <div className="element__checkbox">
                          <Field
                            type="checkbox"
                            name="ALL_CONTRACHS_CHECKED"
                            id="all-checked-checkbox"
                            disabled={values.CONTRACTS.some((contract: any) => !contract.checked) || values.isDeclear === YesNo.Yes}
                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                              e.currentTarget.checked
                                ? apiCommonService.fetchSysTime().then((res: any) => {
                                  setFieldValue('ALL_CONTRACT_CHECKED_TIME', res);
                                })
                                : setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
                              if (e.currentTarget.checked) {
                                // 重置已展開的條款
                                setState((prev: any) => ({
                                  ...prev,
                                  termStatus: commonService.resetTermStatus(state.termStatus)
                                }));
                              }
                            }}
                            onChange={(e: any) => {
                              handleChange(e);
                              resetEvalResult(setFieldValue);
                              resetAllPetTabelData();
                            }}
                          />
                          <div className="element__checkbox-btn" />
                        </div>
                        <span className={'agree-all-terms' + (values.CONTRACTS.some((contract: any) => !contract.checked) || values.isDeclear === YesNo.Yes ? ' grey' : '')}>我已審閱及同意上述條款</span>
                      </label>
                    </div>
                  </div>
                  <div style={{ padding: 20 }}>
                    <div className="element__checkbox-group">
                      <label htmlFor="agreeGetPetList">
                        <div className="element__checkbox">
                          <Field
                            type="checkbox"
                            name="agreeGetPetList"
                            id="agreeGetPetList"
                            onChange={(e: any) => {
                              handleChange(e);
                              resetEvalResult(setFieldValue);
                              resetAllPetTabelData();
                            }}
                          />
                          <div className="element__checkbox-btn" />
                        </div>
                        <span>我同意旺旺友聯產險使用本人會員個人資料及寵物晶片序號向農業部取得被保險寵物資訊，並以該資訊做為實際核保及簽發保險單之依據。</span>
                      </label>
                    </div>
                  </div>
                  <div className="insure-process-building-info__controls">
                    <button
                      type="button"
                      className="element__button element__button--red"
                      onClick={() => getPetListOnClick()}
                      disabled={
                        !values.policyHolderId ||
                        !values.policyHolderBirthday ||
                        !values.agreeGetPetList ||
                        values.isDeclear === '' ||
                        values.isDeclear === YesNo.Yes ||
                        !values.ALL_CONTRACHS_CHECKED
                      }
                    >
                      查詢寵物清單
                    </button>
                  </div>
                </div>
                <div className="building-info__title">寵物資料</div>
                <div className="building-info__content">
                  <div className="building-info__row">
                    <p className="ant-picker-exam-info">預定生效日：新件預設系統日翌日零時，旺旺友聯續保件為續保生效日。</p>
                    <p className="ant-picker-exam-info">寵物險僅接受提前1個月續保，下述清單如遇反灰無法選擇，請待預定生效日前一個月進行續保</p>
                    <p className="ant-picker-exam-info">請確認與【寵物登記資訊網】上的資料相符，若出現無寵物名稱或資料不相符之情形時，請至【具寵登站資格的獸醫院】變更</p>
                  </div>
                  {petTableData &&
                    <Table
                      rowSelection={{
                        type: 'radio',
                        ...rowSelection
                      }}
                      columns={petTableColumns}
                      dataSource={petTableData}
                    />}
                  {/* 保費試算 */}
                  <div className="insure-process-building-info__controls">
                    <button
                      type="submit"
                      className="element__button element__button--red"
                      onClick={() => setSubmitBtnStatus('eval')}
                      disabled={
                        !selectedRow ||
                        !values.agreeGetPetList ||
                        values.isDeclear === '' ||
                        values.isDeclear === YesNo.Yes ||
                        !values.ALL_CONTRACHS_CHECKED
                      }
                    >
                      保費試算
                    </button>
                  </div>
                  {petInfoTableData
                    ? <Table className="pet-info-table" columns={petInfoTableColumns} dataSource={petInfoTableData} pagination={false} />
                    : null}
                  {showCalcPlans && state.evalResult
                    ? <CalcPlansTable calcRef={calcRef} selectedCalcPlan={values.selectedCalcPlan} setSelectedCalcPlan={(plan: string) => setFieldValue('selectedCalcPlan', plan)} evalResult={state.evalResult} evalTableData={state.evalTableData} />
                    : null}
                </div>
                <div className="pet-notice">
                  <span>注意事項：</span>內視鏡手術、導尿手術、細針採樣、電腦斷層掃描..等，若無切開或切除等行為，無法申請手術費用，另口腔疾病、白內障、治療短吻呼吸道症候群所生之費用等不予理賠。
                </div>
                <div className="building-info__content">
                  <div className="building-info__row">
                    {/* 優惠/活動代碼 */}
                    <div className={'element__form-group' + (errors.programId && touched.programId ? ' element__form-group--invalid' : '')}>
                      {/* <div className="element__form-group-title">活動代碼/推薦員編 <span dangerouslySetInnerHTML={{ __html: commonService.getCodeMsg(props.apiInfo.UICode, CodeId.U044) }} /></div> */}
                      <div className="element__form-group-title">活動代碼/推薦員編 <span>{commonService.htmlParser(commonService.getCodeMsg(props.apiInfo.UICode, CodeId.U044))}</span></div>
                      <Field
                        autoComplete="off"
                        type="text"
                        name="programId"
                        data-fieldname="programId"
                        className="element__input"
                        onChange={(e: any) => {
                          handleChange(e);
                        }}
                      />
                      <div className="element__error-message">
                        <ErrorMessage name="programId" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* form1 submit */}
            <div className="insure-process-building-info__controls">
              <button
                type="submit"
                className="element__button element__button--red"
                onClick={() => setSubmitBtnStatus('next')}
                disabled={
                  !isValid ||
                  !values.ALL_CONTRACHS_CHECKED ||
                  values.isDeclear === '' ||
                  values.isDeclear === YesNo.Yes ||
                  values.selectedCalcPlan.PLAN_ID === undefined ||
                  !values.agreeGetPetList
                }
              >
                我要投保
              </button>
            </div>
            <PetFormikFocusError />
          </Form>
        )}
      </Formik>
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGuardianshipStatementModalVisible: (visible: boolean) => dispatch(setGuardianshipStatementModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(InsureProcessTrialCalc);
